export const getControlTranslationKeys = (isBlocked: boolean) => {
  const modalContentKey = isBlocked ? 'common:unblock_confirm_text' : 'common:block_confirm_text';
  const labelContentKey = isBlocked ? 'user:unblock_user' : 'user:block_user';
  return { modalContentKey, labelContentKey };
};
